import PatientMedEventOverviewHeader from './dashboard-patient-medevent-overview-header.component'
import PatientMedEventOverviewPatientDetails from './dashboard-patient-medevent-overview-patient-details.component'
import { useTranslation } from 'react-i18next'
import type { TDashboardPatientMedAlert, TDashboardPatientOverview } from '../dashboard.type'
import { CurecallTag, CurecallTooltip } from '@honestica/curecall-ui'
import { getFormattedDateWithHours } from 'src/utils/date-formatter.util'
import { MED_ALERT_UI_TO_TAG_STATUS } from 'src/types/med-alert'
import { useTimezonePreference } from 'src/providers/timezone-preference.provider'

const DashboardPatientMedEventOverview = ({
  dashboardPatientOverview,
}: {
  dashboardPatientOverview: TDashboardPatientOverview
}) => {
  const { t } = useTranslation()
  const { displayTimezone } = useTimezonePreference()

  if (!dashboardPatientOverview) return null

  const patientMedicalAlertsToShow = dashboardPatientOverview.patientMedAlerts.sort((a, b) => a.id - b.id)

  return (
    <div className="c-flex c-flex-col c-inter-center c-gap-2">
      <PatientMedEventOverviewHeader
        patient={dashboardPatientOverview.patient}
        patientMedEvent={dashboardPatientOverview.patientMedEvent}
      />
      <PatientMedEventOverviewPatientDetails dashboardPatientOverview={dashboardPatientOverview} />
      {dashboardPatientOverview?.patientMedEvent?.status !== 'REVIEWED' &&
        patientMedicalAlertsToShow?.length > 0 && (
          <div className="c-flex c-flex-wrap c-gap-4">
            {patientMedicalAlertsToShow.map((patientMedAlert: TDashboardPatientMedAlert) => (
              <CurecallTooltip
                key={patientMedAlert.id}
                content={getFormattedDateWithHours(t, patientMedAlert.createdAt, false, displayTimezone)}
                tooltipPosition="bottom-start"
              >
                <CurecallTag status={MED_ALERT_UI_TO_TAG_STATUS[patientMedAlert.MedAlert.ui]}>
                  {patientMedAlert.MedAlert.label}
                </CurecallTag>
              </CurecallTooltip>
            ))}
          </div>
        )}
    </div>
  )
}
export default DashboardPatientMedEventOverview
